/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import Button from "../../extras/Button";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import ToggleSwitch from "../../extras/ToggleSwitch";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import Title from "../../extras/Title";
import {
  getAllCategory,
  categoryDelete,
  categoryStatus,
} from "../../../redux/slice/categorySlice";
import { permissionError, warning } from "../../../util/Alert";
import {
  getComplains,
  solveComplain,
} from "../../../redux/slice/complainSlice";
import noImage from "../../../assets/images/noImage.png";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Analytics from "../../extras/Analytics";
import ComplainDialog from "./ComplainDialog";
import { ReactComponent as Edit } from "../../../../src/assets/icon/edit.svg";
import { IconCircleDashedCheck, IconEdit, IconInfoCircle } from "@tabler/icons-react";
import MultiButton from "../../extras/MultiButton";
import ReadMore from "../../extras/ReadMore";
import LazyImage from "../../extras/ImageFallback";

const Complain = () => {
  const { complain, total } = useSelector((state) => state.complain);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [type, setType] = useState(2);
  const [person, setPerson] = useState(1);
  const [person1, setPerson1] = useState("User");
  const hasPermission = useSelector((state) => state.auth.admin.flag);
  const payload = {
    start: page,
    limit: rowsPerPage,
    type,
    person,
  };

  useEffect(() => {
    dispatch(getComplains(payload));
  }, [page, rowsPerPage, type, person]);

  useEffect(() => {
    setData(complain);
  }, [complain]);

  const dispatch = useDispatch();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  function openImage(imageUrl) {
    // Open the image in a new tab or window
    window.open(imageUrl, "_blank");
  }

  const userTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile">
          <LazyImage
            src={row?.image}
            alt="image"
            // className="cursor-pointer"
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
            // onClick={() => openImage(row?.image)}
            height={`100%`}
          />
        </div>
      ),
    },
    {
      Header: "BookingId",
      Cell: ({ row }) => (
        <span className="text-capitalize ">
          {row?.bookingId ? row?.bookingId : "-"}
        </span>
      ),
    },
    {
      Header: "User Name",
      Cell: ({ row }) => (
        <span className="text-capitalize ">
          {row?.userId?.fname
            ? row?.userId.fname + " " + row?.userId.lname
            : "Salon User"}
        </span>
      ),
    },
    {
      Header: "Details",
      thClass: "w-25",
      Cell: ({ row }) => (
        <span className="text-capitalize w-25 ">{<ReadMore text={row?.details} limit={100000} />}</span>

      ),
    },
    {
      Header: "Date",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.date ? row?.date?.split(",")[0] : "-"}
        </span>
      ),
    },
    {
      Header: "Time",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.date ? row?.date?.split(",")[1] : "-"}
        </span>
      ),
    },
    {
      Header: "Status",
      Cell: ({ row }) => (
        <>
          {row?.type == 0 && (
            <button
              className="badge-warning"
            >
              Pending
            </button>
          )}
          {row?.type == 1 && (
            <button className="badge-success">
              Solved
            </button>
          )}
        </>
      ),
    },
    {
      Header: "Action",
      thClass: "text-start",
      Cell: ({ row }) => (
        <div className="action-button justify-content-start">
          <button
            className="btn btn-sm"
            onClick={() =>
              dispatch(openDialog({ type: "complain", data: row }))
            }
          >
            <IconInfoCircle className="text-secondary" />
          </button>
          {row?.type == 0 && (
            <button
              className="btn btn-sm"
              onClick={() => solveComplains(row?._id)}
            >
              <IconCircleDashedCheck className="text-secondary" />
            </button>
          )}
        </div>
      ),
    },
  ];

  const expertTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile">
          <LazyImage
            src={row?.image}
            style={{ height: "50px", width: "50px" }}
            alt="image"
            className="cursor-pointer"
            onClick={() => openImage(row?.image)}
            height={`100%`}
          />
        </div>
      ),
    },
    {
      Header: "BookingId",
      Cell: ({ row }) => (
        <span className="text-capitalize ">
          {row?.bookingId ? row?.bookingId : "-"}
        </span>
      ),
    },
    {
      Header: "Expert Name",
      Cell: ({ row }) => (
        <span className="text-capitalize ">
          {row?.expertId
            ? row?.expertId.fname + " " + row?.expertId.lname
            : "-"}
        </span>
      ),
    },
    {
      Header: "Details",
      thClass: "w-25",
      Cell: ({ row }) => (
        <span className="text-capitalize ">{row?.details}</span>
      ),
    },
    {
      Header: "Date",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.date ? row?.date?.split(",")[0] : "-"}
        </span>
      ),
    },
    {
      Header: "Time",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.date ? row?.date?.split(",")[1] : "-"}
        </span>
      ),
    },
    {
      Header: "Status",
      Cell: ({ row }) => (
        <>
          {row?.type == 0 && (
            <button className=" badge-warning">
              Pending
            </button>
          )}
          {row?.type == 1 && (
            <button className="badge-success">
              Solved
            </button>
          )}
        </>
      ),
    },
    {
      Header: "Action",
      thClass: "text-start",
      Cell: ({ row }) => (
        <div className="action-button justify-content-start">
          <button
            className="btn btn-sm"
            onClick={() =>
              dispatch(openDialog({ type: "complain", data: row }))
            }
          >
            <IconInfoCircle className="text-secondary" />
          </button>
          {row?.type == 0 && (
            <button
              className="btn btn-sm"
              onClick={() => solveComplains(row?._id)}
            >
              <IconCircleDashedCheck className="text-secondary" />
            </button>
          )}
        </div>
      ),
    },
  ];

  const complainType = [
    { name: "PENDING", value: 0 },
    { name: "SOLVED", value: 1 },
  ];

  const personType = {
  Expert: 0,
  User: 1,
};

  const solveComplains = async (id) => {
    if (!hasPermission) return permissionError();
    await dispatch(solveComplain(id));
    window.location.reload();
  };

  return (
    <div className="userPage">
      <div className="multi-user-btn mb-3 ">
        <MultiButton
          multiButtonSelect={person1}
          setMultiButtonSelect={(value)=>{setPerson(personType[value]); setPerson1(value)}}
          label={["User", "Expert"]}
        />
      </div>
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5
                className="main-title">
                Complain
              </h5>
            </div>
            <div className="d-flex gap-2 justify-content-end w-100">
              <div className="inputData w-25">
                <select
                  name="bookingType"
                  className="form-select "
                  id="bookingType"
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                  }}
                >
                  <option
                    value={2}
                    selected
                  >
                    ALL
                  </option>
                  {complainType?.map((data) => {
                    return <option value={data?.value}>{data?.name}</option>;
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* <Title name={"Complain"} /> */}


        <div>
          <Table
            data={data}
            mapData={person == "Expert" ? expertTable : userTable}
            PerPage={rowsPerPage}
            Page={page}
            type={"server"}
          />
          <Pagination
            type={"server"}
            serverPage={page}
            setServerPage={setPage}
            serverPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalData={total}
          />
        </div>
      </div>
        {dialogue && dialogueType === "complain" && (
          <ComplainDialog
            setData={setData}
            data={data}
          />
        )}
    </div>
  );
};

export default Complain;
